<div class="bg-blue persona-container">
    <apc-navbar-big [items]=navigation></apc-navbar-big>
    <div class="content">
        <apc-breadcrumbs [navigationSub]=navigation></apc-breadcrumbs>
        <router-outlet></router-outlet>
    </div>
    <apc-create-persona></apc-create-persona>
</div>